import React from 'react';
import CustomTable from '../../../../../components/Table/CustomTable';
import Loader from '../../../../../components/Loader';
import { violationsColumns } from './TableColumns';

const Table = ({
  isLoading,
  isError,
  error,
  data,
  totalRecords,
  page,
  pageSize,
  setPage,
  setPageSize,
  isRefetching,
}) => {
  console.log(data);
  if (isLoading) {
    return (
      <div className="loader-center">
        <Loader color={"black"} />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="loader-center">
        <p>{error?.response?.data?.message || "Error loading violations"}</p>
      </div>
    );
  }

  return (
    <CustomTable
      initialRows={data}
      columns={violationsColumns}
      headerBgColor={"#F5F5F9"}
      rowCount={totalRecords}
      setPaginationModel={(data) => {
        setPage(data.page);
        setPageSize(data.pageSize);
      }}
      page={page}
      pageSize={pageSize}
      subHeight={302}
      isLoading={isRefetching}
    />
  );
};

export default Table; 